import React, { useEffect, useState } from 'react';
import Head from '../../../../layout/head/Head';
import Content from '../../../../layout/content/Content';
import FeatureUnderDevelopment from '../../../loaders/FeatureUnderDevelopment';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent } from '../../../../components/Component';
import { useDispatch } from 'react-redux';
import * as app_consts from "../../../../utils/app_consts";
import { tenant_auth_actions_helper } from '../../../../actions/actions_helper';
import AuthTenantLoader from '../../../loaders/AuthTenantLoader';
import AuthTenantPageError from '../../../error/AuthTenantPageError';
import { TENANT_RETRIEVE_PRMOTIONS_LIST_API } from '../../../../api/api_data';
import { fail_retrieve_promotions_list, loading_retrieve_promotions_list, reset_retrieve_promotions_list, success_retrieve_promotions_list } from '../../../../reducers/auth_tenant/retrieve_promotions_list_Slice';
import { RETRIEVE_PROMOTIONS_ERROR_MSG, RETRIEVE_PROMOTIONS_SUCCESS_MSG } from '../../../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { messageToast } from '../../../../utils/Utils';
import { Link } from 'react-router-dom';
import AuthTenantNoData from '../../../error/AuthTenantNoData';
import CreatePromotionModal from '../../../../components/modal/promotions/CreatePromotionModal';
import moment from 'moment';
import { Badge } from 'reactstrap';

const PromotionsList = ({ tenant_info, user_info }) => {

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page_data, setPageData] = useState([]);
  const [current_page_data, setCurrentPageData] = useState([]);
  const dispatch = useDispatch();
  const [sm, updateSm] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [create_promotion_modal, setCreatePromotionModal] = useState(false);

  const open_create_promotion_modal = () => {
    setCreatePromotionModal(true);
  };

  const close_create_promotion_modal = () => {
    setCreatePromotionModal(false);
  };

  const create_promotion_modal_successFunction = () => {
    close_create_promotion_modal();
    retrieve_data();
  };

  useEffect(() => {
    retrieve_data();
  }, []);


  const retrieve_data = () => {
    setError("");
    setLoading(true);
    // Retreive Employees
    dispatch(tenant_auth_actions_helper(loading_retrieve_promotions_list, success_retrieve_promotions_list, fail_retrieve_promotions_list, RETRIEVE_PROMOTIONS_ERROR_MSG, RETRIEVE_PROMOTIONS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${TENANT_RETRIEVE_PRMOTIONS_LIST_API}`));
  };
  // Listener
  const retrieve_promotions_list_listener = useSelector((state) => state.retrieve_promotions_list.retrieve_promotions_list);

  useEffect(() => {
    if (retrieve_promotions_list_listener.status !== app_consts.IDLE)
    {
      if (retrieve_promotions_list_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_promotions_list_listener.status === app_consts.FAIL)
        {
          messageToast(retrieve_promotions_list_listener.message, app_consts.FAIL);
          setLoading(false);
          setError(retrieve_promotions_list_listener.message);
        } else if (retrieve_promotions_list_listener.status === app_consts.SUCCESS)
        {
          messageToast(retrieve_promotions_list_listener.message, app_consts.SUCCESS);
          setPageData(retrieve_promotions_list_listener.data);
          setCurrentPageData(retrieve_promotions_list_listener.data);
          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);
        }
        dispatch(reset_retrieve_promotions_list());
      }
    }
  }, [retrieve_promotions_list_listener]);


  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = current_page_data?.slice(indexOfFirstItem, indexOfLastItem);
  // 

  return (
    <>
      <Head
        title={
          tenant_info?.name ? `${tenant_info.name} Promotions List` : ' Promotions List'
        }
      />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Promotions</BlockTitle>
              <BlockDes className="text-soft">
                <p>{!(loading || error) && `Promotions ${current_page_data?.length}`}</p>
              </BlockDes>
              {!(loading) && (
                <div className="mt-2">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      retrieve_data();
                    }}
                  >
                    <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                      <span>Refresh List</span>
                    </Button>
                  </Link>
                </div>
              )}
            </BlockHeadContent>
            {
              !(loading || error) && (
                <>
                  <BlockHeadContent>
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#more"
                        className="btn btn-icon btn-trigger toggle-expand me-n1"
                        onClick={(ev) => {
                          ev.preventDefault();
                          updateSm(!sm);
                        }}
                      >
                        <Icon name="more-v"></Icon>
                      </a>
                      <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                        <ul className="nk-block-tools g-3">
                          <li>
                            <div className="form-control-wrap">
                              <div className="form-icon form-icon-right">
                                <Icon name="search"></Icon>
                              </div>
                              <input
                                type="text"
                                className="form-control"
                                id="default-04"
                                value={searchTerm}
                                onChange={e => setSearchTerm(e.target.value)}
                                placeholder="Search for Promotion"
                              />
                            </div>
                          </li>
                          {
                            (user_info?.roles?.includes(app_consts.ADMINISTRATOR) || user_info?.roles?.includes(app_consts.CREATE_PROMOTION)) && (
                              <>
                                <li className="nk-block-tools-opt">
                                  <Button
                                    className="toggle btn-icon d-md-none"
                                    color="primary"
                                    onClick={() => {
                                      open_create_promotion_modal();
                                    }}
                                  >
                                    <Icon name="plus"></Icon>
                                  </Button>
                                  <Button
                                    className="toggle d-none d-md-inline-flex"
                                    color="primary"
                                    onClick={() => {
                                      open_create_promotion_modal();
                                    }}
                                  >
                                    <Icon name="plus"></Icon>
                                    <span>Create Promotion</span>
                                  </Button>
                                </li>
                              </>
                            )
                          }
                        </ul>
                      </div>
                    </div>
                  </BlockHeadContent>
                </>
              )
            }
          </BlockBetween>
        </BlockHead>
        {
          loading ?
            <>
              <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Promotions..." />
            </>
            :
            <>
              {
                error ?
                  <>
                    <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
                  </>
                  :
                  <>
                    {
                      page_data && page_data?.length > 0 ?
                        <>
                          <Block>
                            <div className="nk-tb-list is-separate is-medium mb-3">
                              <DataTableHead className="nk-tb-item">
                                <DataTableRow>
                                  <span className="sub-text">Name</span>
                                </DataTableRow>
                                <DataTableRow size="mb">
                                  <span className="sub-text">Start Date</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">End Date</span>
                                </DataTableRow>
                                <DataTableRow size="lg">
                                  <span className="sub-text">Type</span>
                                </DataTableRow>
                                <DataTableRow size="lg">
                                  <span className="sub-text">USSD Code</span>
                                </DataTableRow>
                                <DataTableRow size="lg">
                                  <span className="sub-text">Participants</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">Status</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">Action</span>
                                </DataTableRow>
                              </DataTableHead>
                              {/*Head*/}
                              {currentItems.length > 0
                                ? currentItems.map((item) => (
                                  <DataTableItem key={item.id}>
                                    <DataTableRow>
                                      <Link to={`/${tenant_info.url_prefix}/promotions/${item?.id}`}>
                                        <div className="user-card">
                                          <div className="user-info">
                                            <span className="tb-lead">
                                              {item?.name ? item?.name : "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                            </span>
                                          </div>
                                        </div>
                                      </Link>
                                    </DataTableRow>
                                    <DataTableRow size="mb">
                                      <span className="tb-odr-date">{item?.start_date ? moment(item?.start_date).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow size="mb">
                                      <span className="tb-odr-date">{item?.end_date ? moment(item?.end_date).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <span>{item?.type?.replace(/_/g, ' ').toUpperCase() || "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <span>{item?.ussd_code || "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <div className="user-card">
                                        <div className="user-info">
                                          <span className="tb-lead">
                                            {item?.unique_part || "0"}
                                          </span>
                                          <span>ENTRIES | {item?.total_entries ? item?.total_entries : "0"}</span>
                                        </div>
                                      </div>
                                      <span className="tb-sub"></span>

                                    </DataTableRow>
                                    <DataTableRow size="md">
                                      <span className="tb-odr-status">
                                        <Badge
                                          color={
                                            item?.status === app_consts.ACTIVE
                                              ? "success"
                                              : "danger"
                                          }
                                          className="badge-dot"
                                        >
                                          {item?.status?.replace(/_/g, ' ').toUpperCase() || "--"}
                                        </Badge>
                                      </span>
                                    </DataTableRow>
                                    <DataTableRow className="nk-tb-col-tools">
                                      <div className="tb-odr-btns d-none d-sm-inline">
                                        <Link to={`/${tenant_info.url_prefix}/promotions/${item?.id}`}>
                                          <Button color="primary" size="sm" className="btn btn-dim">
                                            View
                                          </Button>
                                        </Link>
                                      </div>
                                      <Button className="btn-pd-auto d-sm-none">
                                        <Icon name="chevron-right"></Icon>
                                      </Button>
                                    </DataTableRow>
                                  </DataTableItem>
                                ))
                                : null}
                            </div>
                            {currentItems?.length > 0 && (
                              <div className="mt-3">
                                <PaginationComponent
                                  itemPerPage={itemPerPage}
                                  totalItems={current_page_data?.length}
                                  paginate={paginate}
                                  currentPage={currentPage}
                                />
                              </div>
                            )}
                          </Block>

                        </>
                        :
                        <>
                          <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Promotions Found"} />
                        </>
                    }
                    <CreatePromotionModal tenant_info={tenant_info} user_info={user_info} successFunction={create_promotion_modal_successFunction} isOpen={create_promotion_modal} closeModal={close_create_promotion_modal} />
                  </>
              }
            </>
        }
      </Content>
    </>
  );
};

export default PromotionsList;